module.exports = __webpack_public_path__ + "static/media/header1200.34bde41a.jpg";